import * as React from "react";
import { IconButton, styled } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { ClinicColors } from "../styles/clinicTheme";
import CloseIcon from "@mui/icons-material/Close";

//region [[ Styles ]]

const LoadingProgressView = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 10,
  justifyContent: "center",
  position: "relative",
});

const IconHolder = styled("span")({
  position: "absolute",
  left: 3,
  top: "50%",
  marginTop: -8,
  color: ClinicColors.primary,
  "& svg": {
    width: 14,
    height: 14,
    fill: "currentcolor",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LoadingProgressProps {
  label: string;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
  onClose?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LoadingProgress = ({ ...props }: LoadingProgressProps) => {
  return (
    <LoadingProgressView style={props.style}>
      {props.icon && <IconHolder>{props.icon}</IconHolder>}
      <CircularProgress size={20} />
      {props.label || "Loading..."}
      {props.onClose && (
        <IconButton onClick={() => props.onClose()} size="small">
          <CloseIcon />
        </IconButton>
      )}
    </LoadingProgressView>
  );
};
